import * as types from "../../constants";
import * as ent from "../../services/enterpriseService";
import * as API from "../../services/APIService";
//import { getEnterpriseServiceByEmail } from "../../services/enterpriseService";
const route = "api/Entids/";

export function getEnterprise() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ENTERPRISE_PENDING });
    return ent
      .getEnterpriseService()
      .then((response) => {
        dispatch({
          type: types.FETCH_ENTERPRISE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_ENTERPRISE_ERROR });
        //console.log(error);
        throw error;
      });
  };
}

export function getEnterpriseByEmail(credential) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ENTERPRISE_PENDING });
    return ent
      .getEnterpriseServiceByEmail(credential)
      .then((response) => {
        dispatch({
          type: types.FETCH_ENTERPRISE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_ENTERPRISE_ERROR });
        //console.log(error);
        throw error;
      });
  };
}

export function updateEnterprise(event) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_ENTERPRISE_PENDING });
    return API.update(route, event)
      .then((response) => {
        dispatch({
          type: types.UPDATE_ENTERPRISE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_ENTERPRISE_ERROR });
        //console.log(error);
        throw error;
      });
  };
}

export function insertEnterprise(event) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_ENTERPRISE_PENDING });
    return API.insert(route, event)
      .then((response) => {
        dispatch({
          type: types.INSERT_ENTERPRISE_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_ENTERPRISE_ERROR });
        //console.log(error);
        throw error;
      });
  };
}
